import React from 'react';

import indieEditionLogo from '../../assets/logos/logo_trqk_iq_indie_edition.svg';
import publisherEditionLogo from '../../assets/logos/logo_trqk_iq_publisher_edition.svg';
import blankEditionLogo from '../../assets/logos/logo_trqk_iq_blank_edition.svg';

interface TrqkIQLogoProps {
    isPublisherEdition: Maybe<boolean>;
    width: number;
}

/**
 * A logo that says "TrqkIQ", with a subtitle that reads "Indie Edition" or "Publisher Edition",
 * based on the `isPublisherEdition` prop. Since this has to be sourced from the user's subscription
 * settings, it will initially be unknown, or null. When this is the case, the logo does not have
 * any subtitle yet, but it is the same size as the final version, to prevent layout shift. When
 * the `isPublisherEdition` prop becomes either true or false, the corresponding subtitle will
 * appear.
 * @param props - {@link TrqkIQLogoProps}
 * @returns JSX
 */
export const TrqkIQLogo = ({
    isPublisherEdition,
    width,
}: TrqkIQLogoProps): JSX.Element => {
    let alt = 'TrqkIQ logo';
    let src = blankEditionLogo;

    switch (isPublisherEdition) {
        case true:
            alt = 'TrqkIQ Publisher Edition Logo';
            src = publisherEditionLogo;
            break;
        case false:
            alt = 'TrqkIQ Indie Edition Logo';
            src = indieEditionLogo;
            break;
        default:
            alt = 'TrqkIQ Logo';
            src = blankEditionLogo;
    }

    return <img alt={alt} src={src} width={width} />;
};
